<template>
  <WdsAlert v-if="error" error data-test="checklist-error">
    {{ $t('The checklists could not be loaded. Try refreshing the page.') }}
  </WdsAlert>

  <div v-else-if="loading" role="status" data-test="checklist-loading" class="tw-flex tw-flex-col tw-gap-4">
    <span class="tw-sr-only">{{ $t('Loading checklists') }}</span>
    <div class="tw-h-5 tw-w-2/3 tw-animate-pulse tw-rounded tw-bg-gray-200" />
    <div class="tw-h-40 tw-animate-pulse tw-rounded-lg tw-bg-gray-200" />
  </div>

  <WdsStack v-else-if="checklists.length > 0" direction-column gap-lg>
    <ChecklistCard v-for="checklist in checklists" :key="checklist.id" :checklist="checklist" />
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { WdsAlert, WdsStack } from '@worksome/wds-components'
import ChecklistCard from './ChecklistCard.vue'
import { graphql } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{
  hireId: string
}>()

const { result, loading, error } = useQuery(
  graphql(`
    query HireChecklists($id: ID!) {
      hire(id: $id) {
        id
        checklists {
          id
          ...ChecklistCard
        }
      }
    }
  `),
  () => ({ id: props.hireId }),
  { clientId: 'publicApi' },
)

const checklists = computed(() => result.value?.hire?.checklists ?? [])
</script>
